import styled from 'styled-components'

const Styled = styled.div`

.wrapper {
  height: 500px;
  position: relative;
  margin: "0"
}
.graphContainer {
  height: 500px;
  position: absolute;
  top: 0px;
  width: 100%;
  margin: "0"
}
.linechart {
  height: 500px;
  position: absolute;
  top: 0px;
  width: 100%;
  margin: "0"
}
  .tooltip {
    padding: 10px;
    background: white;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    position:absolute;
    min-width:300px
  }
  
  .tooltip > div {
    text-align: start;
  }

  .tooltip > .title {
    font-weight: bold;
  }
`

export default Styled
